import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationDetailsService {

  public selectedIds: Set<number>;
  public selectedDeletingItems = [];

  // Observable string sources
  public openJustificationDialog = new BehaviorSubject<boolean>(false);
  public diableFullScreen = new BehaviorSubject<boolean>(false);
  public selectedFilesToAdd = new BehaviorSubject<any[]>([]);
  public filesToBeAddedLength = new BehaviorSubject<number>(11);

  // Observable string streams
  public openJustificationDialog$ = this.openJustificationDialog.asObservable();
  public diableFullScreen$ = this.diableFullScreen.asObservable();
  public selectedFilesToAdd$ = this.selectedFilesToAdd.asObservable();
  public filesToBeAddedLength$ = this.filesToBeAddedLength.asObservable();

  public setOpenJustificationDialogToggle(d) {
    this.openJustificationDialog.next(d);
  }

  public setDiableFullScreenToggle(d) {
    this.diableFullScreen.next(d);
  }

  public setSelectedFilesToAdd(d) {
    this.selectedFilesToAdd.next(d);
  }

  public setFilesToBeAddedLength(d) {
    this.filesToBeAddedLength.next(d);
  }
}